import { Chart } from 'chart.js';

export interface FullPluginDef extends Chart.PluginServiceRegistrationOptions {
	id: string;
}

const defaultOptions = {
	fillColor: '#fcf7ba',
	strokeColor: '#f6f1c1',
	axis: 'x',
	base: 0,
	target: 2
};

function getLineValue(scale: any, index: number, offsetGridLines: boolean) {
	let lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

function hasData(data: any) {
	return data && data.datasets && data.datasets.length > 0;
}

function findScale(chart: Chart, options: { [key: string]: any }) {
	const c: any = chart;
	const scales = Object.keys(c.scales).map((d) => c.scales[d]);
	return scales.find((d) => d.id.startsWith(options.axis));
}

export const improvePlugin: FullPluginDef = {
	id: 'improvearea',

	beforeDraw(chart: Chart, easing, options) {
		options = Object.assign({}, defaultOptions, options);
		const scale = findScale(chart, options);
		if (!hasData(chart.config.data) || !scale) {
			return;
		}

		const ticks: any[] = scale.getTicks();
		if (!ticks || ticks.length === 0) {
			return;
		}
		const { target, base } = options;
		const targetTick = ticks.findIndex((v) => v.value === target);

		const isHorizontal: boolean = scale.isHorizontal();
		const { chartArea } = chart;
		const { /* left: chartLeft, */ top, right, bottom } = chartArea;

		const soptions = scale.options;
		const gridLines = soptions.gridLines;

		const ctx = chart.ctx!;
		ctx.save();

		ctx.fillStyle = options.fillColor;
		ctx.strokeStyle = options.strokeColor;
		ctx.setLineDash([3, 3]);

		const tickPositions = ticks.map((_: any, index: number) =>
			getLineValue(scale, index, gridLines.offsetGridLines && ticks.length > 1)
		);
		tickPositions.push(isHorizontal ? right : bottom);

		const [leftPos, rightPos] = targetTick > -1 ? [tickPositions[base], tickPositions[targetTick]] : [0, 0];

		const left = leftPos;
		const width = rightPos - leftPos;
		const height = bottom - top;

		ctx.fillRect(left, top, width, height);
		ctx.strokeRect(left, top, width, height);

		if (options.label.enabled) {
			const {
				text,
				strokeColor,
				fontSize = 8,
				fontStyle = 'normal',
				fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif'
			} = options.label;
			const chartHelpers = Chart.helpers;
			ctx.font = chartHelpers.fontString(fontSize, fontStyle, fontFamily);
			const labelX = left + width / 2;
			const labelY = 0;
			ctx.fillStyle = strokeColor;
			ctx.strokeStyle = strokeColor;
			ctx.textBaseline = 'top';
			ctx.textAlign = 'center';
			ctx.fillText(text, labelX, labelY);
		}

		ctx.restore();
	}
};
